export default __webpack_public_path__ + "static/media/loop.7a1bce92.mp3";